/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ElevationResponse', 'model/ErrorResponse', 'model/GeoResponseLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ElevationResponse'), require('./ErrorResponse'), require('./GeoResponseLink'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ElevationsResponse = factory(root.GisServerApis.ApiClient, root.GisServerApis.ElevationResponse, root.GisServerApis.ErrorResponse, root.GisServerApis.GeoResponseLink);
  }
}(this, function(ApiClient, ElevationResponse, ErrorResponse, GeoResponseLink) {
  'use strict';




  /**
   * The ElevationsResponse model module.
   * @module model/ElevationsResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ElevationsResponse</code>.
   * A response includes a collection of elvations.
   * @alias module:model/ElevationsResponse
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>ElevationsResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ElevationsResponse} obj Optional instance to populate.
   * @return {module:model/ElevationsResponse} The populated <code>ElevationsResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('totalCount')) {
        obj['totalCount'] = ApiClient.convertToType(data['totalCount'], 'Number');
      }
      if (data.hasOwnProperty('data')) {
        obj['data'] = ApiClient.convertToType(data['data'], [ElevationResponse]);
      }
      if (data.hasOwnProperty('lowestElevation')) {
        obj['lowestElevation'] = ApiClient.convertToType(data['lowestElevation'], 'Number');
      }
      if (data.hasOwnProperty('highestElevation')) {
        obj['highestElevation'] = ApiClient.convertToType(data['highestElevation'], 'Number');
      }
      if (data.hasOwnProperty('averageElevation')) {
        obj['averageElevation'] = ApiClient.convertToType(data['averageElevation'], 'Number');
      }
      if (data.hasOwnProperty('link')) {
        obj['link'] = GeoResponseLink.constructFromObject(data['link']);
      }
      if (data.hasOwnProperty('error')) {
        obj['error'] = ErrorResponse.constructFromObject(data['error']);
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String');
      }
      if (data.hasOwnProperty('elapsedTime')) {
        obj['elapsedTime'] = ApiClient.convertToType(data['elapsedTime'], 'String');
      }
    }
    return obj;
  }

  /**
   * The total count of the records.
   * @member {Number} totalCount
   */
  exports.prototype['totalCount'] = undefined;
  /**
   * A collection of elevations.
   * @member {Array.<module:model/ElevationResponse>} data
   */
  exports.prototype['data'] = undefined;
  /**
   * The lowest value in the collection of response elevations.
   * @member {Number} lowestElevation
   */
  exports.prototype['lowestElevation'] = undefined;
  /**
   * The highest value in the collection of response elevations.
   * @member {Number} highestElevation
   */
  exports.prototype['highestElevation'] = undefined;
  /**
   * The average value in the collection of response elevations.
   * @member {Number} averageElevation
   */
  exports.prototype['averageElevation'] = undefined;
  /**
   * @member {module:model/GeoResponseLink} link
   */
  exports.prototype['link'] = undefined;
  /**
   * @member {module:model/ErrorResponse} error
   */
  exports.prototype['error'] = undefined;
  /**
   * @member {String} status
   */
  exports.prototype['status'] = undefined;
  /**
   * @member {String} elapsedTime
   */
  exports.prototype['elapsedTime'] = undefined;



  return exports;
}));



